import React, { useEffect, useState } from "react";
import "../../assets/css/layout.css";
import "../../assets/css/homepage.css";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import RunningCard from "./RunningCard";
import AppLoader from "../Components/AppLoader";
import socket from "../Components/socket";
import acceptSound from "../../assets/audio/accept.mp3";
import { MdOutlineDelete } from "react-icons/md";
import { apiRequest } from "../../apiService/allApi";

export default function Homepage({ rungame, homePlay, users }) {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const history = useHistory();

  let str;

  const [challangeReqRun, setChallangeReqRun] = useState(false);

  const [game_amount, setGame_amt] = useState();

  const [gameData, setGameData] = useState({});

  const [submitProcess, setProcess] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const userId = localStorage.getItem("userId");
  const [disable, setDisable] = React.useState(challangeReqRun);
  const [disable_play, setDisable_play] = React.useState(false);
  const [startingGameId, setStartingGameId] = useState(null);
  const [GameList, setGameList] = useState(homePlay);
  const [runningsGames, setRunningsGames] = useState([]);

  const req_chall_fun = (allgameId) => {
    getPost(allgameId);
  };

  const disablebtn = (id) => {
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 10000);
  };

  const disable_play_btn = () => {
    setDisable_play(true);
    setTimeout(() => {
      setDisable_play(false);
    }, 3000);
  };

  const [game_type, setGame_type] = useState(
    useLocation().pathname.split("/")[2],
  );
  const [game_type2, setGame_type2] = useState(
    useLocation().pathname.split("/")[3],
  );
  const [Game_Ammount, setGame_Ammount] = useState("");

  const ChallengeCreate = async (e) => {
    setIsloading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (game_type == "ludoClassicManual") {
      if (Game_Ammount >= 50 && Game_Ammount <= 50000) {
        try {
          const res = await apiRequest(
            `challange/create`,
            "POST",
            { Game_Ammount, Game_type: game_type },
            headers,
          );
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
            setGame_Ammount("");
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            setTimeout(() => {}, 500);
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 50 and less 50000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else if (game_type == "ludoClassicRich") {
      if (Game_Ammount >= 550 && Game_Ammount <= 200000) {
        try {
          const res = await apiRequest(
            `challange/create`,
            "POST",
            { Game_Ammount, Game_type: game_type },
            headers,
          );
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
            setGame_Ammount("");
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            setTimeout(() => {}, 500);
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 550 and less 200000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else {
      try {
        const res = await apiRequest(
          `challange/create`,
          "POST",
          { Game_Ammount, Game_type: game_type },
          headers,
        );

        setGame_amt(res?.data?.data?.Game_Ammount);

        if (res.data.status == false) {
          setIsloading(false);
          Swal.fire({
            title: res.data.msg,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "you have already enrolled") {
          setIsloading(false);
          Swal.fire({
            title: "You have already enrolled",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "You can set maximum 2 battle.") {
          setIsloading(false);
          Swal.fire({
            title: "You can set maximum 2 battle.",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Insufficient balance") {
          setIsloading(false);
          Swal.fire({
            title: "Insufficient balance",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (
          res.data.msg ===
          "Game amount should be Greater then 50 and less then 50000"
        ) {
          setIsloading(false);
          Swal.fire({
            title: "Game amount should be Greater then 50 and less then 50000",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Set Battle in denomination of 50") {
          setIsloading(false);
          Swal.fire({
            title: "Set Battle in denomination of 50",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Technical Issue, Try after an hour!") {
          setIsloading(false);
          Swal.fire({
            title: "Technical Issue, Try after an hour!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          setIsloading(false);
          setGame_Ammount("");
        }
      } catch (e) {
        setIsloading(false);
        if (e?.response?.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
          setTimeout(() => {}, 500);
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: "Please refresh!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
      }
    }
  };

  const [MyopenBattle, setMyOpenBattle] = useState([]);
  const [OtheropenBattle, setOtherMyOpenBattle] = useState([]);
  const [MyrunningBattle, setMyRunningBattle] = useState([]);
  const [OtherrunningBattle, setOtherRunningBattle] = useState([]);

  useEffect(() => {
    socket.emit("getgamelist", userId);
    socket.on("setGamelist", (data) => {
      setGameList(data);
    });
  }, []);

  useEffect(() => {
    socket.on("gameCreate", (data) => {
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (data?.Created_by?._id === userId) {
          setGame_Ammount("");
        }
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });
    socket.on("deletebat", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item._id !== data,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item._id !== data,
        );
        return updatedOtheropenBattle;
      });
    });

    socket.on("gameUpdate", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });

    socket.on("startAccepted", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });

      if (data.Status === "running" && data?.Created_by?._id === userId) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      } else if (
        data.Status === "running" &&
        data?.Accepetd_By?._id === userId
      ) {
        if (!MyopenBattle?.some((item) => item?._id === data?._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtherrunningBattle?.some((item) => item?._id === data?._id)) {
          setOtherRunningBattle((OtherrunningBattle) => [
            data,
            ...OtherrunningBattle,
          ]);
        }
      }
    });

    socket.on("acceptor_seen_game", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
    socket.on("challangeAccept", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item._id !== data._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item._id !== data._id,
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
  }, [socket]);

  function winnAmount(gameAmount) {
    let profit = null;
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  useEffect(() => {
    let owenedCreated = [];
    let remainingGame = [];

    GameList?.openBattle?.forEach(function (ele) {
      if (ele)
        if (
          (ele?.Created_by?._id == userId || ele?.Accepetd_By?._id == userId) &&
          (ele?.Status == "new" || ele?.Status == "requested")
        ) {
          owenedCreated.push(ele);
        } else if (ele?.Status == "new") {
          remainingGame.push(ele);
        } else if (
          ele?.Status == "running" &&
          ele?.Accepetd_By?._id == userId &&
          ele?.Acceptor_seen === false
        ) {
          owenedCreated.push(ele);
        }
    });
    setMyOpenBattle(owenedCreated);
    setOtherMyOpenBattle(remainingGame);
    let owenedRunning = [];
    let remainingRunning = [];
    GameList?.runningBattle?.forEach(function (ele) {
      if (ele.Created_by && ele.Accepetd_By)
        if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
          owenedRunning.push(ele);
        } else {
          remainingRunning.push(ele);
        }
    });
    setMyRunningBattle(owenedRunning);

    setOtherRunningBattle(remainingRunning);
  }, [GameList]);

  useEffect(() => {
    socket.on("resultUpdateReq1", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });

      if (data.Status === "cancelled" || data.Status === "completed") {
        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedowenedRunning;
        });
        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedrunningGames;
        });
      } else {
        const isUserOwned =
          data?.Created_by?._id === userId || data?.Accepetd_By?._id === userId;

        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          if (isUserOwned) {
            updatedowenedRunning.push(data);
          }
          return updatedowenedRunning;
        });

        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          if (!isUserOwned) {
            updatedrunningGames.push(data);
          }
          return updatedrunningGames;
        });
      }
    });
  }, [socket, userId]);

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      setTimeout(() => {}, 500);
    }

    return () => {};
  }, []);

  const RunningGames = async () => {
    const currentToken = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${currentToken}`,
    };

    try {
      const res = await apiRequest(
        `challange/running/all`,
        "GET",
        null,
        headers,
      );
      const list = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.data)
          ? res.data.data
          : [];
      setRunningsGames(list);
    } catch (e) {
      console.error("RunningGames error:", e);
    }
  };

  const AcceptChallang = async (id) => {
    if (str == 1) {
      Swal.fire({
        title: "Other request in process",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
    str = 1;
    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/accept/${id}`,
        "PUT",
        { Accepetd_By: headers, Acceptor_by_Creator_at: Date.now() },
        headers,
      );
      setGameData({
        accept_by: res.data.Accepetd_By,
        created_by: res.data.Created_by,
      });

      str = 0;
      if (res.data.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "you have already enrolled") {
        Swal.fire({
          title: "You have already enrolled",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Insufficient balance") {
        Swal.fire({
          title: "Insufficient balance",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Game already start with other player") {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {}, 500);
      }
      if (e.response.status == 400) {
        Swal.fire({
          title: e.response.data,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const RejectGame = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/reject/${id}`,
        "PUT",
        { Accepetd_By: null, Status: "new", Acceptor_by_Creator_at: null },
        headers,
      );
      if (res) {
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {}, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const deleteChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/delete/${_id}`,
        "DELETE",
        null,
        headers,
      );
      if (res.data.status == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      if (e?.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {}, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const updateChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/running/update/${_id}`,
        "PUT",
        { Acceptor_seen: true },
        headers,
      );
      if (res) {
        localStorage.setItem("timeOver", "timeStart");
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {}, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const getPost = async (Id) => {
    if (game_type === "ludoClassicManual" || game_type === "ludoClassicRich") {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest(
            "challange/requested/running/" + Id,
            "PATCH",
            {},
            headers,
          );
          setProcess(true);
          setChallangeReqRun(false);
          setStartingGameId(null);
          setDisable(false);

          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          setStartingGameId(null);
          setDisable(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      } else {
        setStartingGameId(null);
      }
    } else {
      setStartingGameId(null);
    }
  };

  useEffect(() => {
    RunningGames();
  }, []);

  const CARD_ACCENT_COLORS = [
    "#a855f7", // Purple
    "#0ea5e9", // Sky Blue
    "#10b981", // Emerald Green
    "#f59e0b", // Amber / Golden
    "#ec4899", // Rose / Pink
  ];

  const isRichMode = game_type === "ludoClassicRich";
  const minBattleAmount = isRichMode ? 550 : 50;
  const maxBattleAmount = isRichMode ? 200000 : 50000;

  const numericAmt = parseFloat(Game_Ammount);
  const isValidAmount =
    !isNaN(numericAmt) &&
    numericAmt >= minBattleAmount &&
    numericAmt <= maxBattleAmount;

  const filteredMyOpen = (MyopenBattle || []).filter(
    (allgame) => allgame?.Game_type === game_type,
  );
  const filteredOtherOpen = (OtheropenBattle || []).filter(
    (allgame) => allgame?.Game_type === game_type,
  );
  const totalOpenBattles = filteredMyOpen.length + filteredOtherOpen.length;

  const getRunningBattlesList = () => {
    const list = [];
    const seen = new Set();

    const checkAndAdd = (runnig) => {
      if (!runnig || !runnig._id || seen.has(runnig._id)) return;

      const isGameMatch =
        runnig.Game_type == game_type ||
        game_type === "ludoClassicManual" ||
        runnig.Game_type === "ludoClassicManual";

      const isStatusMatch =
        runnig.Status === "running" ||
        runnig.Status === "pending" ||
        runnig.Status === "conflict";

      if (isGameMatch && isStatusMatch) {
        seen.add(runnig._id);
        list.push(runnig);
      }
    };

    if (Array.isArray(MyrunningBattle)) {
      MyrunningBattle.forEach(checkAndAdd);
    }
    if (Array.isArray(OtherrunningBattle)) {
      OtherrunningBattle.forEach(checkAndAdd);
    }
    if (Array.isArray(runningsGames)) {
      runningsGames.forEach(checkAndAdd);
    }

    return list;
  };

  const allRunningBattles = getRunningBattlesList();

  return (
    <>
      <div className="leftContainer page_layout">
        <div className="Orher_page_main_section">
          {JSON.parse(localStorage.getItem("sitSetting"))
            ?.ludoClassicManualMsg && (
            <div className="alrt_msg_div">
              <h5>
                {
                  JSON.parse(localStorage.getItem("sitSetting"))
                    ?.ludoClassicManualMsg
                }
              </h5>
            </div>
          )}

          {/* Create Battle Section (Inspired by user screenshot) */}
          {JSON.parse(localStorage.getItem("sitSetting")) !== "undefined" &&
          JSON.parse(localStorage.getItem("sitSetting"))?.gameSearch ===
            true ? (
            <div className="hp_create_container">
              <div className="hp_create_header_row">
                <span className="hp_create_heading_text">CREATE A BATTLE!</span>
                <NavLink to="/Rules" className="hp_rules_anchor">
                  <span>RULES</span>
                  <span className="hp_rules_icon_circle">ⓘ</span>
                </NavLink>
              </div>

              <div className="hp_input_box_wrapper">
                <span className="hp_currency_badge">Rs</span>
                <input
                  className="hp_real_amount_input"
                  type="tel"
                  placeholder={`Enter amount (min ${minBattleAmount})`}
                  value={Game_Ammount}
                  onChange={(e) => setGame_Ammount(e.target.value)}
                />
                {!isLoading ? (
                  addCaseSetting?.gameSearch && game_type2 !== "new" ? (
                    <button
                      className="hp_btn_set_action"
                      disabled={!isValidAmount}
                      onClick={(e) => {
                        e.preventDefault();
                        ChallengeCreate();
                      }}
                    >
                      SET
                    </button>
                  ) : null
                ) : (
                  <button className="hp_btn_set_action" disabled>
                    <AppLoader size="sm" color="white" />
                  </button>
                )}
              </div>

           
            </div>
          ) : null}

          {/* ---------------- Open Battles Section ---------------- */}
          <div className="hp_section_banner_row">
            <div className="hp_section_banner_left">
              <div className="hp_swords_round_icon">⚔️</div>
              <div className="hp_section_banner_text">
                <h3 className="hp_section_main_title">OPEN BATTLES</h3>
                <span className="hp_section_sub_tagline">
                  JOIN &amp; WIN EXCITING PRIZES
                </span>
              </div>
            </div>
            <span className="hp_section_arrow_right">&gt;</span>
          </div>

          {/* Empty State */}
          {totalOpenBattles === 0 && (
            <div className="hp_empty_state_text">
              No open battles currently. Create one above to play!
            </div>
          )}

          {/* My Open Battles */}
          {filteredMyOpen.map((allgame, idx) => {
            const isCreator = userId === allgame?.Created_by?._id;
            const creatorName = allgame?.Created_by?.Name || "Player";
            const shortName =
              creatorName.length > 10
                ? `${creatorName.slice(0, 10)}..`
                : creatorName;

            const accentColor =
              CARD_ACCENT_COLORS[idx % CARD_ACCENT_COLORS.length];
            const avatarImg = allgame?.Created_by?.avatar
              ? baseUrl + allgame?.Created_by?.avatar
              : `${process.env.PUBLIC_URL}/images/avatars/Avatar${(idx % 6) + 1}.png`;

            return (
              <div
                key={allgame._id}
                className="hp_match_card"
                style={{ "--accent-bar-color": accentColor , "borderColor":accentColor }}
              >
                <div className="hp_match_card_content">
                  <div className="hp_match_left_section">
                    <div
                      className="hp_avatar_ring_box"
                      style={{ borderColor: accentColor }}
                    >
                      <img
                        src={avatarImg}
                        alt="avatar"
                        className="hp_avatar_inner_img"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `${process.env.PUBLIC_URL}/images/avatars/Avatar1.png`;
                        }}
                      />
                    </div>

                    <div className="hp_match_middle_details">
                      <div className="hp_top_player_line">
                        <span className="hp_badge_open_pill my_battle_pill">
                          OPEN
                        </span>
                        <span className="hp_player_name_label">
                          {shortName}
                        </span>
                      </div>

                      <div className="hp_stakes_grid">
                        <div className="hp_stake_column">
                          <span className="hp_stake_micro_label">
                            ENTRY FEE
                          </span>
                          <span className="hp_stake_big_value">
                            ₹ {allgame?.Game_Ammount}
                          </span>
                        </div>

                        <div className="hp_stake_column">
                          <span className="hp_stake_micro_label">PRIZE</span>
                          <span className="hp_stake_big_value prize_text">
                            <span className="hp_trophy_emoji">🏆</span>
                            <span>
                              {allgame?.Game_Ammount +
                                winnAmount(allgame?.Game_Ammount)}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="hp_match_action_right">
                    {/* Creator Waiting State */}
                    {isCreator && allgame?.Status === "new" && (
                      <div className="hp_waiting_host_box">
                        <div className="hp_waiting_loader_badge">
                          <AppLoader size="xs" color="amber" />
                          
                        </div>
                        <button
                          className="hp_btn_trash_delete"
                          onClick={() => deleteChallenge(allgame?._id)}
                          title="Delete"
                        >
                          <MdOutlineDelete />
                        </button>
                      </div>
                    )}

                    {/* Creator Requested State */}
                    {isCreator && allgame?.Status === "requested" && (
                      <div className="hp_host_requested_controls">
                        <button
                          className="hp_btn_start_emerald"
                          disabled={startingGameId === allgame?._id || disable}
                          onClick={() => {
                            setStartingGameId(allgame?._id);
                            disablebtn(allgame?._id);
                            req_chall_fun(allgame?._id);
                          }}
                        >
                          {startingGameId === allgame?._id ? (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
                              <AppLoader size="xs" color="white" />
                              <span>START</span>
                            </div>
                          ) : (
                            "START >"
                          )}
                        </button>
                        <button
                          className="hp_btn_decline_gray"
                          disabled={startingGameId === allgame?._id}
                          onClick={() => RejectGame(allgame?._id)}
                        >
                          Decline
                        </button>
                      </div>
                    )}

                    {/* Acceptor Requested State */}
                    {!isCreator && allgame?.Status === "requested" && (
                      <div className="hp_host_requested_controls">
                        <span className="hp_waiting_loader_badge">
                          Requested
                        </span>
                        <button
                          className="hp_btn_decline_gray"
                          onClick={() => RejectGame(allgame?._id)}
                        >
                          Cancel
                        </button>
                      </div>
                    )}

                    {/* Running State */}
                    {!isCreator && allgame?.Status === "running" && (
                      <div>
                        <audio src={acceptSound} autoPlay></audio>
                        <button
                          className="hp_btn_start_emerald"
                          disabled={startingGameId === allgame?._id}
                          onClick={() => {
                            setStartingGameId(allgame?._id);
                            disablebtn();
                            updateChallenge(allgame?._id);
                            history.push(`/viewgame/${allgame?._id}`, {
                              prevPath: window.location.pathname,
                            });
                          }}
                        >
                          {startingGameId === allgame?._id ? (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
                              <AppLoader size="xs" color="white" />
                              <span>START</span>
                            </div>
                          ) : (
                            "START >"
                          )}
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Acceptor alert for host */}
                {isCreator && allgame?.Status === "requested" && (
                  <div className="hp_opponent_alert_bar">
                    <audio src={acceptSound} autoPlay></audio>
                    <img
                      src={
                        allgame?.Accepetd_By?.avatar
                          ? baseUrl + allgame?.Accepetd_By?.avatar
                          : `${process.env.PUBLIC_URL}/images/avatars/Avatar1.png`
                      }
                      alt="avt"
                    />
                    <span>
                      <b>{allgame?.Accepetd_By?.Name || "Player"}</b> wants to
                      play!
                    </span>
                  </div>
                )}
              </div>
            );
          })}

          {/* Other Players' Open Battles */}
          {filteredOtherOpen.map((allgame, idx) => {
            const isCreator = userId === allgame?.Created_by?._id;
            const creatorName = allgame?.Created_by?.Name || "Player";
            const shortName =
              creatorName.length > 10
                ? `${creatorName.slice(0, 10)}..`
                : creatorName;

            const accentColor =
              CARD_ACCENT_COLORS[(idx + 2) % CARD_ACCENT_COLORS.length];
            const avatarImg = allgame?.Created_by?.avatar
              ? baseUrl + allgame?.Created_by?.avatar
              : `${process.env.PUBLIC_URL}/images/avatars/Avatar${(idx % 6) + 1}.png`;

            return (
              <div
                key={allgame._id}
                className="hp_match_card"
                style={{ "--accent-bar-color": accentColor }}
              >
                <div className="hp_match_card_content">
                  <div className="hp_match_left_section">
                    <div
                      className="hp_avatar_ring_box"
                      style={{ borderColor: accentColor }}
                    >
                      <img
                        src={avatarImg}
                        alt="avatar"
                        className="hp_avatar_inner_img"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `${process.env.PUBLIC_URL}/images/avatars/Avatar1.png`;
                        }}
                      />
                    </div>

                    <div className="hp_match_middle_details">
                      <div className="hp_top_player_line">
                        <span className="hp_badge_open_pill">OPEN</span>
                        <span className="hp_player_name_label">
                          {shortName}
                        </span>
                      </div>

                      <div className="hp_stakes_grid">
                        <div className="hp_stake_column">
                          <span className="hp_stake_micro_label">
                            ENTRY FEE
                          </span>
                          <span className="hp_stake_big_value">
                            ₹ {allgame?.Game_Ammount}
                          </span>
                        </div>

                        <div className="hp_stake_column">
                          <span className="hp_stake_micro_label">PRIZE</span>
                          <span className="hp_stake_big_value prize_text">
                            <span className="hp_trophy_emoji">🏆</span>
                            <span>
                              {allgame?.Game_Ammount +
                                winnAmount(allgame?.Game_Ammount)}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="hp_match_action_right">
                    {/* Play Button with iconic Golden Amber gradient */}
                    {!isCreator && allgame?.Status === "new" && (
                      <button
                        className="hp_btn_play_golden"
                        disabled={disable_play}
                        onClick={() => {
                          disable_play_btn();
                          AcceptChallang(allgame?._id);
                        }}
                      >
                        PLAY &gt;
                      </button>
                    )}

                    {/* Host requested controls */}
                    {isCreator && allgame?.Status === "requested" && (
                      <div className="hp_host_requested_controls">
                        <button
                          className="hp_btn_start_emerald"
                          disabled={startingGameId === allgame?._id || disable}
                          onClick={() => {
                            setStartingGameId(allgame?._id);
                            disablebtn(allgame?._id);
                            req_chall_fun(allgame?._id);
                          }}
                        >
                          {startingGameId === allgame?._id ? (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
                              <AppLoader size="xs" color="white" />
                              <span>START</span>
                            </div>
                          ) : (
                            "START >"
                          )}
                        </button>
                        <button
                          className="hp_btn_decline_gray"
                          disabled={startingGameId === allgame?._id}
                          onClick={() => RejectGame(allgame?._id)}
                        >
                          ✕
                        </button>
                      </div>
                    )}

                    {/* Host delete button */}
                    {isCreator && allgame?.Status === "new" && (
                      <button
                        className="hp_btn_trash_delete"
                        onClick={() => deleteChallenge(allgame?._id)}
                      >
                        <MdOutlineDelete />
                      </button>
                    )}

                    {/* Running start button */}
                    {!isCreator && allgame?.Status === "running" && (
                      <>
                        <audio src={acceptSound} autoPlay></audio>
                        <button
                          className="hp_btn_start_emerald"
                          disabled={startingGameId === allgame?._id}
                          onClick={() => {
                            setStartingGameId(allgame?._id);
                            disablebtn();
                            updateChallenge(allgame?._id);
                            history.push(`/viewgame/${allgame?._id}`);
                          }}
                        >
                          {startingGameId === allgame?._id ? (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
                              <AppLoader size="xs" color="white" />
                              <span>START</span>
                            </div>
                          ) : (
                            "START >"
                          )}
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {allgame?.Status === "requested" && !isCreator && (
                  <div className="hp_requester_waiting_strip">
                    <audio src={acceptSound} autoPlay></audio>
                    <AppLoader size="xs" color="amber" style={{ marginRight: "6px" }} />
                    <span>Waiting for Host to accept...</span>
                  </div>
                )}
              </div>
            );
          })}

          {/* ---------------- Running Battles Section ---------------- */}
          <div className="hp_section_banner_row mt-4">
            <div className="hp_section_banner_left">
              <div className="hp_swords_round_icon fire_icon">🔥</div>
              <div className="hp_section_banner_text">
                <h3 className="hp_section_main_title">RUNNING BATTLES</h3>
                <span className="hp_section_sub_tagline running_tagline">
                  LIVE ONGOING MATCHES
                </span>
              </div>
            </div>
            <span className="hp_section_arrow_right">&gt;</span>
          </div>

          {allRunningBattles.length === 0 && (
            <div className="hp_empty_state_text">
              No battles currently running
            </div>
          )}

          {allRunningBattles.map((runnig) => (
            <RunningCard
              key={runnig._id}
              runnig={runnig}
              user={users}
              winnAmount={winnAmount}
              game_type={game_type}
            />
          ))}
        </div>
      </div>
    </>
  );
}
